import { IconProps } from "../../../types/style";

const ArrowUpFillType3SVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.095 1.5H3.905C2.085 1.5 1 2.585 1 4.405V8.59C1 10.415 2.085 11.5 3.905 11.5H8.09C9.91 11.5 10.995 10.415 10.995 8.595V4.405C11 2.585 9.915 1.5 8.095 1.5ZM8.41 5.91C8.265 6.055 8.025 6.055 7.88 5.91L6.375 4.405V9.5C6.375 9.705 6.205 9.875 6 9.875C5.795 9.875 5.625 9.705 5.625 9.5V4.405L4.12 5.91C3.975 6.055 3.735 6.055 3.59 5.91C3.515 5.835 3.48 5.74 3.48 5.645C3.48 5.55 3.52 5.45 3.59 5.38L5.735 3.235C5.805 3.165 5.9 3.125 6 3.125C6.1 3.125 6.195 3.165 6.265 3.235L8.41 5.38C8.555 5.525 8.555 5.76 8.41 5.91Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ArrowUpFillType3SVG;
